import { Injectable, ElementRef, NgZone } from '@angular/core';
import { ConnectionPositionPair, Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';

import { CartNotificationComponent } from '@shared/components/cart-notification/cart-notification.component';

import { CartNotificationOverlayRef } from './cart-notification-overlay-ref';

interface CartNotificationDialogConfig {
    width?: string;
    height?: string;
    panelClass?: string;
    hasBackDrop?: boolean;
    backdropClass?: string;
}

const DEFAULT_CONFIG: CartNotificationDialogConfig = {
    width: '200px',
    height: '200px',
    panelClass: 'cart-notification-panel',
    hasBackDrop: false,
    backdropClass: 'no-backdrop',
};

@Injectable({
    providedIn: 'root'
})

export class CartNotificationService {

    cartRef: ElementRef;

    constructor(
        private overlay: Overlay,
        private ngZone: NgZone
    ) { }

    open(config: CartNotificationDialogConfig = {}) {
        const dialogConfig = { ...DEFAULT_CONFIG, ...config };

        const overlayRef = this.createOverlay(dialogConfig);

        const dialogRef = new CartNotificationOverlayRef(overlayRef);

        const cartNotificationPortal = new ComponentPortal(CartNotificationComponent);

        overlayRef.attach(cartNotificationPortal);

        this.ngZone.runOutsideAngular(() => {
            setTimeout(() => {
                dialogRef.close();
            }, 3000);
        });
    }

    setElementReference(ref: ElementRef) {
        this.cartRef = ref;
    }

    private createOverlay(config: CartNotificationDialogConfig) {
        // Returns an OverlayConfig
        const overlayConfig = this.getOverlayConfig(config);
        // Returns an OverlayRef
        return this.overlay.create(overlayConfig);
    }

    private getOverlayConfig(config): OverlayConfig {
        const positionStrategy = this.overlay.position().flexibleConnectedTo(this.cartRef)
        .withPositions(
            [
                new ConnectionPositionPair({
                    //overlay will be attached at bottom-left of the referenced element
                    originX: 'start',
                    originY: 'bottom'
                }, {
                    //top-left of the overlay with attached to the origin
                    overlayX: 'start',
                    overlayY: 'top'
                })
            ]
        );

        const overlayConfig = new OverlayConfig({
            width: config.width,
            hasBackdrop: config.hasBackdrop,
            backdropClass: config.backdropClass,
            panelClass: config.panelClass,
            scrollStrategy: this.overlay.scrollStrategies.reposition(),
            positionStrategy
        });
        return overlayConfig;
    }
}
